import React from "react";

import MainContainer from "./MainContainer";

interface MainLayoutProps {
  children: React.ReactNode;
  contentPadding: string | number;
  hasBackButton: boolean;
  hasMenuButton: boolean;
  title: string;
  onGoBack?: () => void;
}

const defaultProps = {
  contentPadding: "15px",
  hasBackButton: false,
  hasMenuButton: true,
  title: "공뿌마켓 POS",
};

function MainLayout(props: MainLayoutProps) {
  return <MainContainer {...props} />;
}

MainLayout.defaultProps = defaultProps;

export default MainLayout;
